import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { NgxsModule } from "@ngxs/store";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";
import { TagTypeMenuSelectorComponent } from "./tag-type-menu-selector.component";

@NgModule({
  imports: [CommonModule, MatIconModule, NgxsModule.forFeature([TagManagerState])],
  declarations: [TagTypeMenuSelectorComponent],
  exports: [TagTypeMenuSelectorComponent]
})
export class TagTypeMenuSelectorModule {}
